export const SUPPORT_EMAIL = 'hello@culturalcalculator.co';
export const SUPPORT_TEL = '+44 (07867 786 444)';
export const AUTHORITY_URL = 'https://ico.org.uk/concerns';
export const AUTHORITY_TEL = '0303 123 1113';

export const MAX_JOURNAL_TEXT_CHARS = 530;

export const ALL_OPTIONS_VALUE = 'all';
export const CUSTOM_OPTIONS_VALUE = 'custom';

export const SORT_OPTIONS = {
  ASC: 'asc',
  DESC: 'desc',
};
